import { proposeExternalCalendarEventTime as _proposeExternalCalendarEventTime } from '@griply/services';
import {
  CalendarEventWriteResult,
  ProposeCalendarEventTimeInput,
} from '@griply/types';
import { httpsCallable } from 'firebase/functions';
import { getErrorReporter } from 'shared/services/error-tracking';

import { getFunctions } from './helpers';

export const proposeExternalCalendarEventTime = async (
  payload: ProposeCalendarEventTimeInput,
): Promise<CalendarEventWriteResult> => {
  try {
    return await _proposeExternalCalendarEventTime({
      functions: getFunctions(),
      httpsCallable,
      payload,
    });
  } catch (error: unknown) {
    getErrorReporter().captureException(error, {
      tags: { source: 'external-calendars-propose-new-time' },
    });
    throw error;
  }
};
